import queryString from 'query-string';
import cookie from 'js-cookie';
import isEmpty from 'lodash/isEmpty';

import { AUTH_SESSION_STORAGE_KEY, EMAIL, ACCESS_TOKEN } from 'constants/auth';

export const BASE_URL = process.env.REACT_APP_SERVER_URL;

const request = async (url, options) => {
  try {
    let rawResponse = await fetch(url, options);

    if (options.headers.Accept === 'application/json') {
      rawResponse = await rawResponse.json();
    }

    if (rawResponse.status.code === 401) {
      window.location.replace('/login');
    }
    if (rawResponse.status.code < 200 || rawResponse.status.code >= 300) {
      throw rawResponse.status;
    }

    if (options.headers.Accept === 'application/zip') {
      return rawResponse;
    }

    return rawResponse.data;
  } catch(error) {
    throw error;
  }
};

export function getAuthToken() {
  return cookie.get('AH__AUTH_TOKEN');
}

const get = async (endpoint, initialOptions = {}) => {
  const authToken = getAuthToken();

  const { query, ...otherOptions } = initialOptions;
  const options = {
    ...otherOptions,
    headers: {
      Accept: 'application/json',
      Authorization: authToken,
      'Cache-Control': 'no-cache',
      ...otherOptions.headers
    },
    method: 'GET',
  };

  const url = `${BASE_URL}${endpoint}${!isEmpty(query) ? `${queryString.stringify(query)}`: ''}`;

  return await request(url, options);
};

const post = async (endpoint, initialOptions = {}, method = 'POST') => {
  const authToken = getAuthToken();

  const { body, ...otherOptions } = initialOptions;
  const options = {
    ...otherOptions,
    body: JSON.stringify(body || {}),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      Authorization: authToken,
      ...otherOptions.headers
    },
    method,
  };

  const url = `${BASE_URL}${endpoint}`;

  return await request(url, options);
};


const put = async (endpoint, initialOptions) => post(endpoint, initialOptions, 'PUT');

export default {
  get,
  put,
  post,
};
